import { render, staticRenderFns } from "./data1.vue?vue&type=template&id=1d323a9f&scoped=true"
import script from "./data1.vue?vue&type=script&lang=js"
export * from "./data1.vue?vue&type=script&lang=js"
import style0 from "./data1.vue?vue&type=style&index=0&id=1d323a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d323a9f",
  null
  
)

export default component.exports